import http from "./httpClient.js";

export async function submitFeedback(data, payloadToken) {
    const response = await http.post(`/feedback`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}
